











import { Component, Vue } from "vue-property-decorator";
import { getPanko, PankoData } from "@/router/panko";

export interface Breadcrumb {
  panko: PankoData;
  disabled: boolean;
}

@Component
export default class BreadCrumb extends Vue {
  get pankoData(): Breadcrumb[] {
    const pankoList = getPanko(
      this.$route.matched[this.$route.matched.length - 1].path
    );
    return pankoList.map((panko, index) => ({
      panko,
      disabled: index === pankoList.length - 1
    }));
  }
}
